export default () => ({
  feeds: [],
  entity: 'feed',
  entities: 'feeds',
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/components/feed/resources/data.js